import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { useLang } from "../i18n/LangContext";

/** Browser-framed screenshot card for a case study. */
export const WorkCard = ({ p, i, offset = false }) => {
  const { path, t } = useLang();
  return (
    <Reveal delay={i * 0.1} className={offset ? "md:mt-24" : ""}>
      <Link to={`${path("work")}#${p.slug}`} className="group block" data-testid={`work-card-${p.slug}`}>
        <div className="overflow-hidden rounded-sm border border-white/10 bg-char">
          <div className="flex items-center gap-2 border-b border-white/10 px-4 py-3">
            <span className="h-2 w-2 rounded-full bg-white/20" /><span className="h-2 w-2 rounded-full bg-white/20" /><span className="h-2 w-2 rounded-full bg-lav" />
            <span className="label ml-4 truncate text-[10px] text-mist">{p.url.replace(/https:\/\/(www\.)?/, "").replace(/\/$/, "")}</span>
          </div>
          <div className="aspect-[4/3] overflow-hidden">
            <img src={p.img} alt={`${p.name}: ${t.a11y.siteHome}`} loading="lazy"
              className="h-full w-full object-cover object-top transition-transform duration-[1.4s] ease-out group-hover:scale-[1.04]" />
          </div>
        </div>
        <div className="mt-6 flex items-start justify-between gap-6">
          <div>
            <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-ivory md:text-3xl">{p.name}</h3>
            <p className="label mt-2 text-mist">{p.meta}</p>
          </div>
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/15 text-ivory transition-colors duration-300 group-hover:border-lav group-hover:bg-lav group-hover:text-ink">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
};
